_options$pathInfoPara